<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import {getMultipleAnalyticsAvg, getAnalyticsMinMaxDates } from "@/api/analytics";
import { percentage_format } from "@/utils.js";
import swal from "sweetalert";
import moment from "moment";
const startOfMonth = moment()
  .subtract(1, "months")
  .startOf("month")
  .format("YYYY-MM-DD");

const endOfMonth = moment()
  .subtract(1, "months")
  .endOf("month")
  .format("YYYY-MM-DD");
export default {
  name: "kpi-summary",
  components: {
    VueCtkDateTimePicker
  },
  props: ["locations","location_groups"],
  data() {
    return {
      msg: null,
      loading: true,
      form: {
        category: "sales",
        location: [],
        location_group: [],
        selectedYearOver: 1,
        selectedLocationOrGroup: "locations"
      },
      yoyCategoryView: "These values are reported in Year over Year changes",
      dtpicker: { start: startOfMonth, end: endOfMonth },
      dt: "",
      categories: [],
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      chartOptions: {},
      seriesOptions: [],
      items: [],
      categoryOptions: [
        { text: "Sales", value: "sales" },
        { text: "Traffic", value: "traffic" },
        { text: "Average Check", value: "average_check" },
        { text: "Frequency", value: "frequency" },
        { text: "Recency", value: "recency" }
      ],
      overYearOption: [
        { text: "Year over Year", value: 1},
        { text: "Year over 2 Years", value: 2}
      ],
      locationOrGroupOptions: [
        { text: "Locations", value: "locations"},
        { text: "Location Groups", value: "location_groups"}
      ],
      selectedLocations: [],
      selectedLocationGroups: [],
      dataReady: false,
      snackbar: false,
      text: "",
      timeout: 2000,
      minDate: "",
      maxDate: moment().format("YYYY-MM-DD"),
      searchTerm: null,
      selectedItems: [],
      locationsCopy: [],
      locationsOptions: [],
      searchLocationGroupTerm: null,
      selectedLocationGroupItems: [],
      locationGroupsCopy: [],
      locationGroupsOptions: [],
      maxDisplay: 1,
      firstLoadDone: false
    };
  },
  async mounted() {
    let index = this.getIndex(this.locations);
    let selected = this.locations[index];
    this.form.location = {
      value: selected.pos_id,
      text: `${selected.name} ${selected.full_address}`,
      name: selected.name,
      full_address: selected.full_address,
    };
    this.selectedItems.push(this.form.location);
    let group_index = this.getIndex(this.location_groups);
    let selected_group = this.location_groups[group_index];
    this.form.location_group = {
      value: selected_group.id,
      text: `${selected_group.name}`,
      name: selected_group.name,
    };
    this.selectedLocationGroupItems.push(this.form.location_group);
    let end =
      this.dtpicker && this.dtpicker.end ? `- ${this.dtpicker.end}` : "";
    this.dt = `${this.dtpicker.start}${end}`;
    // setTimeout(() => {
    //   this.setLocations();
    //   this.setLocationGroups();
    // }, 2000);

    this.setLocations();
    this.setLocationGroups();

    setTimeout(() => {
      // this.getAnalyticsMinMaxDates();
      this.onSearch();
    }, 1000);

    this.dataReady = true;
  },
  computed: {
    subtitle() {
      let text = null;
      if (this.form.category === "sales") {
        text = "Sales: Customer spend";
      }
      if (this.form.category === "traffic") {
        text = "Traffic: Number of customer visits";
      }
      if (this.form.category === "average_check") {
        text = "Average Check: Average customer check ";
      }
      if (this.form.category === "frequency") {
        text =
          "Frequency: Average number of visits by the same customer in the past three months";
      }
      if (this.form.category === "recency") {
        text =
          "Recency: Average number of days since their last visit by customers who have visited before";
      }
      return text;
    },
    likesAllItems() {
      return this.selectedItems.length === 30 || this.selectedItems.length == this.locationsOptions.length;
    },
    likesSomeItem() {
      return this.selectedItems.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    likesAllGroupItems() {
      return this.selectedLocationGroupItems.length === 30 || this.selectedLocationGroupItems.length === this.locationGroupsOptions.length;
    },
    likesSomeGroupItem() {
      return this.selectedLocationGroupItems.length > 0 && !this.likesAllGroupItems;
    },
    groupicon() {
      if (this.likesAllGroupItems) return "mdi-close-box";
      if (this.likesSomeGroupItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  watch: {
    locations(){
      this.setLocations()
    },
    location_groups(){
      this.setLocationGroups()
    },
    dtpicker(newVal) {
      if (newVal == undefined) {
        let last365 = moment().subtract(1, "years");
        last365 = last365.format("YYYY-MM-DD");
        let today = moment();
        today = today.format("YYYY-MM-DD");

        this.dtpicker = { start: last365, end: today };
      }
    },
    "selectedItems"(){
      this.loading = false
      if (this.selectedItems.length > 30 && this.form.selectedLocationOrGroup != 'location_groups') {
        this.$nextTick(() => {
          this.selectedItems = [...this.selectedItems].slice(0, 30)
        })
        swal("Notice", "You've selected too many locations to analyze. Try creating a group of locations to analyze instead")
      }
    },
    "selectedLocationGroupItems"(){
      this.loading = false
      if (this.selectedLocationGroupItems.length > 30 && this.form.selectedLocationOrGroup != 'locations') {
        this.selectedLocationGroupItems = this.selectedLocationGroupItems.slice(0, 30)
        swal("Notice", "You've selected too many groups to analyze. Try by selecting fewer than 30 groups")
      }
    },
    "form.selectedLocationOrGroup"(){
      console.log("form selectedLocationOrGroup",this.form.selectedLocationOrGroup);
    }
  },
  methods: {
    setLocations() {
      this.locationsOptions = [
        ...this.locations.map((list) => {
          return {
            value: list.pos_id,
            text: `${list.name.replace(list.full_address, '')}`,
            name: `${list.name.replace(list.full_address, '')}`,
            full_address: list.full_address,
            street: list.street,
            city: list.city,
            state: list.state,
            country: list.country,
            zip: list.zip,
          };
        }),
      ];
      this.locationsCopy = [...this.locationsOptions];
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.selectedItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationsOptions.length; i++) {
            let item = this.locationsOptions[i];
            data.push(item);
          }
          this.selectedItems = data;
        }
      });
    },
    filterLocations() {
      if (!this.searchTerm || this.locationsOptions.length == 0) {
        this.locationsOptions = this.locationsCopy;
      }
      this.locationsOptions = this.locationsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationsBlur(vl){
      this.searchTerm = null
      this.filterLocations()
    },
    setLocationGroups() {
      this.locationGroupsOptions = [
        ...this.location_groups.map((list) => {
          return {
            value: list.id,
            text: `${list.name}`,
            name: list.name
          };
        }),
      ];
      this.locationGroupsCopy = [...this.locationGroupsOptions];
    },
    toggleLocationGroup() {
      this.$nextTick(() => {
        if (this.likesAllGroupItems) {
          this.selectedLocationGroupItems = [];
        } else {
          let data = [];
          for (let i = 0; i < this.locationGroupsOptions.length; i++) {
            let item = this.locationGroupsOptions[i];
            data.push(item);
          }
          this.selectedLocationGroupItems = data;
        }
      });
    },
    filterLocationGroups() {
      if (!this.searchLocationGroupTerm || this.locationGroupsOptions.length == 0) {
        this.locationGroupsOptions = this.locationGroupsCopy;
      }
      this.locationGroupsOptions = this.locationGroupsOptions.filter((item) => {
        return (
          item.text.toLowerCase().indexOf(this.searchLocationGroupTerm.toLowerCase()) > -1
        );
      });
    },
    filterLocationGroupBlur(){
      this.searchLocationGroupTerm = null
      this.filterLocationGroups()
    },
    getIndex(obj) {
      return Math.floor(Math.random() * obj.length);
    },
    customLabel({ name, street }) {
      return `${name} – ${street}`;
    },
    limitText(count) {
      return `and ${count} other locations`;
    },
    async getAnalyticsMinMaxDates() {
      const payload = ""; //this was the location of pos_id but object type, removing this
      //add new parameter for selected groups in getAnalyticsMinMaxDates
      if (this.form.selectedLocationOrGroup == 'locations'){
        const response = await getAnalyticsMinMaxDates(
          payload,
          this.selectedItems,
          [],
          'locations'
        );

        if (response) {
          this.minDate = response.min_date; // this set the limit of daterange in DT within avaiable date from pos_id
          this.maxDate = response.max_date;
        }
      } else if (this.form.selectedLocationOrGroup == 'location_groups'){
        const response = await getAnalyticsMinMaxDates(
          payload,
          [],
          this.selectedLocationGroupItems,
          'location_groups'
        );

        if (response) {
          this.minDate = response.min_date; // this set the limit of daterange in DT within avaiable date from pos_id
          this.maxDate = response.max_date;
        }
      }
    },
    dateModifier(date){
      return moment(date).add(6, 'days');
    },
    async onSearch() {
      if (this.form.selectedLocationOrGroup == 'locations' && this.selectedItems.length == 0) {
        swal("No locations detected", "Please select at least one location");
        return;
      }
      else if (this.form.selectedLocationOrGroup == 'location_groups' && this.selectedLocationGroupItems.length == 0) {
        swal("No location groups detected", "Please select at least one location group");
        return;
      }
      // await this.getAnalyticsMinMaxDates(); // placing await, this require to run first before  getMultipleAnalytics
      if (!this.firstLoadDone) {
        this.firstLoadDone = true;

        let current = new Date();
        let enddate = `${current.getFullYear()}-${current.getMonth() +
          1}-${current.getDate()}`;
        let startdate = `${current.getFullYear() - 1}-${current.getMonth() +
          1}-${current.getDate()}`;

        this.dtpicker.start = startdate; // this set the value of date picker //initial first load set date range
        this.dtpicker.end = enddate;
      }

      this.loading = true;
      const payload = JSON.parse(
        JSON.stringify({
          start_date: this.dtpicker.start,
          end_date: this.dtpicker.end,
        })
      );

      //const results = await getMultipleAnalyticsAvg(payload, this.selectedItems, this.form.selectedYearOver);
      //add new parameter for selected groups in getAnalyticsMinMaxDates
      //logic for next block pending
      let results = null;
      if (this.form.selectedLocationOrGroup == 'locations'){
       results = await getMultipleAnalyticsAvg(payload, this.selectedItems, this.form.selectedYearOver,[],'locations');
      }
      else{
        results = await getMultipleAnalyticsAvg(payload, [], this.form.selectedYearOver,this.selectedLocationGroupItems,'location_groups');
      }
      // const results = await getMultipleAnalytics(payload, this.selectedItems, this.form.selectedYearOver);
      this.yoyCategoryView = `These values are reported in ${this.overYearOption[this.form.selectedYearOver - 1].text} changes `
      if (results && results.length > 0) {
        // Get all baselines
        // let baselines = result.map(item => item.baseline);
        // Filter baselines
        // baselines = baselines.filter((v, i, a) => a.indexOf(v) === i);
        // console.log("baselines", baselines);
        let result = results;
        const registered_baselines = ["industry", "compset", "self", "segment"];
        // Get all dates
        let dates = result.map(item => item.date);


        // Filter dates
        dates = dates
          .filter((v, i, a) => a.indexOf(v) === i)
          .sort((a, b) => new Date(a) - new Date(b));
        // console.log("dates", dates);
        let categories = dates;
        // console.log("categories", categories);
        let series = [];
        for (let i = 0; i < registered_baselines.length; i++) {
          let data = [];
          let baseline = registered_baselines[i];
          // console.log("baseline", baseline);
          for (let x = 0; x < dates.length; x++) {
            let d = dates[x];
            // console.log("d", d);
            let filter_results = results.filter(
              (obj) => obj.baseline == baseline && obj.date == d
            );
            // console.log("filter_results", filter_results.length);
            if (filter_results.length > 0) {
              if (this.form.category === "sales") {
                let total_sales = filter_results
                  .map((item) =>
                    item.sales !== "NaN" ? parseFloat(item.sales) : 0
                  )
                  .reduce(x => x);
                data.push(total_sales);
              }
              if (this.form.category === "traffic") {
                let total_traffic = filter_results
                  .map((item) =>
                    item.traffic !== "NaN" ? parseFloat(item.traffic) : 0
                  )
                  .reduce(x => x);
                data.push(total_traffic);
              }
              if (this.form.category === "average_check") {
                let total_average_check = filter_results
                  .map((item) =>
                    item.average_check !== "NaN"
                      ? parseFloat(item.average_check)
                      : 0
                  )
                  .reduce(x => x);
                data.push(total_average_check);
              }
              if (this.form.category === "frequency") {
                let total_frequency = filter_results
                  .map((item) =>
                    item.frequency !== "NaN" ? parseFloat(item.frequency) : 0
                  )
                  .reduce(x => x);
                data.push(total_frequency);
              }
              if (this.form.category === "recency") {
                let total_recency = filter_results
                  .map((item) =>
                    item.recency !== "NaN" ? parseFloat(item.recency) : 0
                  )
                  .reduce(x => x);
                data.push(total_recency);
              }
            }
          }
          series.push({
            name: baseline,
            data: data,
            description: `this is ${baseline} tootltip`,
          });
        }
        this.seriesOptions = series;
        this.chartOptions = {
          chart: {
            height: 400,
            type: "area",
            toolbar: {
              show: true,
              tools: {
                download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
                customIcons: [],
              },
            },
            events: {
              updated: () => {
                this.setLegendTooltip(registered_baselines);
              },
              mounted: () => {
                this.setLegendTooltip(registered_baselines);
              },
            },
          },
          colors: ["#2E93fA", "#66DA26", "#FF9800", "#E91E63"],
          dataLabels: {
            enabled: false,
            formatter: function(val) {
              return `${val}`;
            },
          },
          stroke: {
            curve: "smooth",
          },
          title: {
            text: ``,
            align: "left",
          },
          subtitle: {
            text: this.subtitle,
            align: "left",
          },
          xaxis: {
            type: "datetime",
            categories: categories,
            labels: {
              formatter: function (value, timestamp) {
                value = moment(value).add(6, 'days');
                return moment(value).format('MMM-DD-YYYY')
              }, 
            }
          },
          yaxis: {
            show: false,
            showAlways: false,
            labels: {
              show: false,
              formatter: function(val) {
                return `${percentage_format(val)}`;
              },
            },
          },
          tooltip: {
            x: {
              format: "dd/MM/yy",
              show: true,
            },
            marker: {
              show: true,
            },
          },
          legend: {
            onItemHover: {
              highlightDataSeries: true,
            },
          },
        };
        this.snackbar = true;
        this.text = `${this.form.location.name} result...`;
      } else {
        this.chartOptions = {};
        this.seriesOptions = [];
        this.snackbar = true;
        this.text = "No result found";
      }
      this.loading = false;
    },
    setLegendTooltip(series) {
      // console.log("series", series);
      if (series && series.length > 0) {
        for (let i = 0; i < series.length; i++) {
          let idx = i + 1;
          let id = `.apexcharts-legend-series[rel="${idx}"]`;
          let element = document.querySelectorAll(`${id}`);
          // console.log("element", element[0]);
          if (element && element[0]) {
            element[0].classList.add("apexcharts-legend-default-overflow");
          }
        }
        var boxElem = document.querySelectorAll(
          ".apexcharts-legend-default-overflow"
        );
        boxElem.forEach((item) => {
          item.addEventListener("mouseenter", mouseenter);
          item.addEventListener("mouseleave", mouseleave);
        });
      }

      function mouseenter(event) {
        let element = event.target;
        let seriesname = element.getAttribute("seriesname");
        let tooltip = document.getElementById(`tooltip-card-${seriesname}`);
        tooltip.style.display = "block";
      }
      function mouseleave(event) {
        let element = event.target;
        let seriesname = element.getAttribute("seriesname");
        let tooltip = document.getElementById(`tooltip-card-${seriesname}`);
        tooltip.style.display = "none";
      }
    },
    whenDtClosed() {
      if (this.dtpicker.end == null && this.dtpicker.start != null) {
        this.dtpicker.end = this.dtpicker.start;
      }
    }
  }
};
</script>

<style>
.v-text-field--outlined >>> fieldset {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.v-list {
  max-width: 100%;
}

.v-menu__content {
  max-width: 300px !important;
  /* border: blue solid 2px; */
}
</style>

<template>
  <div>
    <v-overlay :value="loading">
      <div class="text-center">
        <p>Loading ...</p>
        <v-progress-circular indeterminate size="30"></v-progress-circular>
      </div>
    </v-overlay>
    <h3>KPI SUMMARY</h3>
    <div
      class="mt-n5 py-2 py-lg-4 d-flex align-items-center justify-content-center"
    >
      <div class="mr-2" style="width: 200px;">
        <VueCtkDateTimePicker
          @is-hidden="whenDtClosed()"
          id="benchmark-analytics-summary-dtpicker"
          v-model="dtpicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select date range"
          :min-date="minDate"
          :max-date="maxDate"
          range
        />
      </div>
      <div class="mr-2 mt-6" style="width: 200px;">
        <v-select
          v-model="form.selectedYearOver"
          :items="overYearOption"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div>
      <div class="mr-2 mt-6" style="width: 200px;">
        <v-select
          v-model="form.category"
          :items="categoryOptions"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div>
      <div class="mr-2 mt-6" style="width: 200px;">
        <v-select
          v-model="form.selectedLocationOrGroup"
          :items="locationOrGroupOptions"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div>
      <div class="mr-2 mt-6">
        <v-select
          v-if="form.selectedLocationOrGroup == 'locations'"
          v-model="selectedItems"
          :items="locationsOptions"
          label="Location"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          return-object
          style="position: relative; z-index: 4;"
          multiple
          :menu-props="{ top: false, offsetY: true }"
        >
          <template v-slot:prepend-item>
            <div>
              <div style="padding: 10px 15px;">
                <v-text-field
                  v-model="searchTerm"
                  placeholder="Search"
                  @input="filterLocations"
                  @blur="filterLocationsBlur"
                ></v-text-field>
              </div>
            </div>
            <v-divider class="mt-2"></v-divider>
            <div @click="toggle">
              <div class="pl-4">
                <v-icon
                  :color="selectedItems.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ icon }}
                </v-icon>
                <span class="pl-8">Select All</span>
              </div>
            </div>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template
            v-if="selectedItems.length > 1"
            v-slot:selection="{ item, index }"
          >
            <span v-if="index === maxDisplay">
              {{ selectedItems.length }} locations selected
            </span>
          </template>
          <template slot="item" slot-scope="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.full_address }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </div>
      
      <div class="mr-2 mt-6">
        <v-select
          v-if="form.selectedLocationOrGroup == 'location_groups'"
          v-model="selectedLocationGroupItems"
          :items="locationGroupsOptions"
          label="Group Location"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          return-object
          style="position: relative; z-index: 4;"
          multiple
          :menu-props="{ top: false, offsetY: true }"
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="searchLocationGroupTerm"
                  placeholder="Search"
                  @input="filterLocationGroups"
                  @blur="filterLocationGroupBlur"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
            <v-list-item ripple @click="toggleLocationGroup">
              <v-list-item-action>
                <v-icon
                  :color="selectedLocationGroupItems.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ groupicon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template
            v-if="selectedLocationGroupItems.length > 1"
            v-slot:selection="{ item, index }"
          >
            <span v-if="index === maxDisplay">
              {{ selectedLocationGroupItems.length }} location groups selected
            </span>
          </template>
          <template slot="item" slot-scope="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
                <!-- <v-list-item-subtitle>
                  {{ item.full_address }}
                </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </div>

      <div>
        <v-btn
          depressed
          color="primary"
          @click="onSearch"
          :loading="loading"
          :disabled="loading"
          id="myBtn"
        >
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </div>
    </div>
    <v-alert outlined type="info" text class="outer-container yoy-category">
       {{ yoyCategoryView }}
    </v-alert>
    <v-card flat class="mb-20">
      <apexchart
        :options="chartOptions"
        :series="seriesOptions"
        type="area"
        height="300"
        style="position:relative; z-index: 1;"
      ></apexchart>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip-card-industry"
        style="display: none;"
      >
        <v-card-text>
          All of the metrics are reported year over year.<br />The
          <strong>industry</strong> category are restaurants in your local
          market, defined as an 8-minute drive around your location.
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip-card-self"
        style="display: none;"
      >
        <v-card-text>
          All of the metrics are reported year over year.<br />The
          <strong>self</strong> category are your restaurant locations that
          you've included in the filter.
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip-card-segment"
        style="display: none;"
      >
        <v-card-text>
          All of the metrics are reported year over year.<br />The
          <strong>segment</strong> category are restaurants in the same category
          as your location in your local market. Your local market is defined as
          an 8-minute drive around your location, and segment is defined by
          check averages as quick service (&#60;$12), casual dining ($12 - $50),
          or fine dining (> $50).
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip-card-compset"
        style="display: none;"
      >
        <v-card-text>
          All of the metrics are reported year over year.<br />The
          <strong>compset</strong> category are restaurants we added to your
          default compset based upon where else your customers shop, or
          restaurants you added to your compset manually.
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>
